"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLanguageCode = void 0;
const languageCodeList_1 = require("./languageCodeList");
function isLanguageCode(value) {
    if (typeof value !== "string") {
        return false;
    }
    return languageCodeList_1.languageCodeList.includes(value);
}
exports.isLanguageCode = isLanguageCode;
//# sourceMappingURL=isLanguageCode.js.map